<template>
    <div :style="theme">
        <layout :fo_config="this.fo_config" :account_title="'MES RENDEZ-VOUS'">
            <div id="spacer"></div>
            <div class="container">
                <div class="tabs is-centered">
                    <ul id='account-tabs'>
                        <li v-if="!this.redirected" id='infos-tab' class="is-active" @click="switchTab('#infos-tab', 'MesInformations')">
                            <a>
                                <span>Mes informations</span>
                            </a>
                        </li>
                        <li id="rdvs-tab" :class="fo_config['redirected'] == 1 ? 'is-active' : ''" @click="switchTab('#rdvs-tab', 'MesRendezVous')">
                            <a>
                                <span>Mes rendez-vous</span>
                            </a>
                        </li>
                    </ul>
                </div>
                <section class="section">
                    <component :is="activeComponent" :fo_config="fo_config"></component>
                </section>
            </div>
        </layout>
    </div>
</template>

<script>
import layout from './Layout.vue'
import MesInformations from './Account/MesInformations.vue'
import MesRendezVous from './Account/MesRendezVous.vue'
export default {
    components : {layout, MesInformations, MesRendezVous},
    name : 'Account',
    props: ['fo_config'],
    data () {
        return {
            activeComponent: this.fo_config['redirected'] == 1 ? 'MesRendezVous' : 'MesInformations'
        }
    },
    mounted() {
        document.querySelector('#rdvs-tab').click();
    },
    methods : {
        switchTab (tab_id, component) {
            let ul = document.querySelector('#account-tabs')
            for (let elt of ul.children) {
                elt.classList.remove('is-active')
            }
            let li = document.querySelector(tab_id)
            li.classList.add('is-active')
            this.activeComponent = component

        }
    },
    computed: {
        theme(){
            return this.fo_config['theme'];
        },
        redirected(){
            return this.fo_config && (this.fo_config['redirected'] == 1);
        },
        redirected(){
            return this.fo_config && (this.fo_config['redirected'] == 1);
        },
        redirect_params(){
            if(!this.redirected){
                return '';
            }
            let url = window.location.href;
            // let params = url.substring(url.lastIndexOf('/')+1).replace('times','');
            let params = url.split('?',2)[1];
            return '?'+params+'&redirected=1';     
        }        
    }
}
</script>
